// extracted by mini-css-extract-plugin
module.exports = {"startDateField":"EventForm_startDateField__15xzF","endDateField":"EventForm_endDateField__2QOJx","textField":"EventForm_textField__2dyJP"};